import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { AboutPage, ContactPage, CopyrightPage, DisclaimerPage, PrivacyPage, TermsPage } from './pages/Legal'
import { ContentDetailPage } from './pages/ContentDetail'
import { DeitiesPage, DeityDetailPage } from './pages/Deities'
import { DownloadsPage } from './pages/Downloads'
import { HomePage } from './pages/Home'
import { LyricsPage } from './pages/Lyrics'
import { SearchPage } from './pages/Search'
import { SongsPage } from './pages/Songs'
import { DeiveegamTheriyumaPage } from './pages/DeiveegamTheriyuma'
import { NavratriGiveawayPage, NavratriTrialPage } from './pages/NavratriGiveaway'
import { ArticleDetailPage, SpiritualPage } from './pages/Spiritual'
import { StutisPage } from './pages/Stutis'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default function App() {
  return (
    <>
      <a className="skip-link" href="#main">
        முதன்மை உள்ளடக்கத்திற்குச் செல்
      </a>
      <Header />
      <main id="main" className="main">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/songs" element={<SongsPage />} />
          <Route path="/stutis" element={<StutisPage />} />
          <Route path="/lyrics" element={<LyricsPage />} />
          <Route path="/deities" element={<DeitiesPage />} />
          <Route path="/deities/:deityId" element={<DeityDetailPage />} />
          <Route path="/spiritual" element={<SpiritualPage />} />
          <Route path="/spiritual/:slug" element={<ArticleDetailPage />} />
          <Route path="/deiveegam-theriyuma" element={<DeiveegamTheriyumaPage />} />
          <Route path="/deiveegam-theriyuma/" element={<DeiveegamTheriyumaPage />} />
          <Route path="/navratri" element={<NavratriGiveawayPage />} />
          <Route path="/navratri/" element={<NavratriGiveawayPage />} />
          <Route path="/navratri-trial" element={<NavratriTrialPage />} />
          <Route path="/navratri-trial/" element={<NavratriTrialPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/narayani-stuti-tamil-lyrics-meaning" element={<ContentDetailPage />} />
          <Route path="/narayani-stuti-tamil-lyrics-meaning/" element={<ContentDetailPage />} />
          <Route
            path="/content/narayani-stuti-tamil-lyrics-meaning"
            element={<Navigate to="/narayani-stuti-tamil-lyrics-meaning/" replace />}
          />
          <Route
            path="/content/narayani-stuti-tamil-lyrics-meaning/"
            element={<Navigate to="/narayani-stuti-tamil-lyrics-meaning/" replace />}
          />
          <Route path="/content/:slug" element={<ContentDetailPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/copyright" element={<CopyrightPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  )
}
